import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_nwecvb9e2v: FaireBrandEntity = {
  token: "b_nwecvb9e2v",
  type: "brand",
  name: "Enchanted Soul",
  avatarUrl:
    "https://cdn.faire.com/fastly/6d56e386c3f1fe9468f7d425b59c971b31ec833f2ca8de2b45fe2a868e5d0e0f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ac98a827e39aec98145265176eeca0c791224b44bf304c6cfbb8862517203b3e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6d56e386c3f1fe9468f7d425b59c971b31ec833f2ca8de2b45fe2a868e5d0e0f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ac98a827e39aec98145265176eeca0c791224b44bf304c6cfbb8862517203b3e.png",
  location: "Eureka springs, AR, USA",
  minimumOrderDollars: 139,
  rating: 4.6,
  reviewCount: 5,
  isTopShop: true,
  isInsider: true,
  description:
    "Enchanted Soul is your gateway to the mystical and magical. We specialize in handcrafted ritual herbs, spell kits, spell jars, and crystals, all designed to inspire intention and transformation. Our carefully curated collection is perfect for modern witches, spiritual seekers, and anyone looking to embrace their inner magic. Whether you're enhancing rituals or creating sacred spaces, Enchanted Soul offers high-quality, ethically sourced tools to elevate your practice and enchant your world.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:40.938Z",
    importedBy: "entity-db-cli",
  },
};
